export default __webpack_public_path__ + "static/media/doctor7.29960da6.jpg";